module.exports = __webpack_public_path__ + "h5/img/icon_1.0a5b055e.png";